<h2 mat-dialog-title>{{ (data.taskName || 'Task') + ' Report' }}</h2>

<mat-dialog-content>
  <div class="stage" [class.is-loading]="previewLoading">
    <div class="stage-skeleton" [class.is-hidden]="!previewLoading" [attr.aria-hidden]="!previewLoading">
      <div class="capture-loading">
        <div class="capture-overlay">
          <div class="skeleton preview-skel"></div>
          <div class="capture-spinner">
            <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
            <div class="muted">Preparing preview...</div>
          </div>
        </div>
        <div class="skeleton line-skel"></div>
        <div class="skeleton line-skel"></div>
      </div>
    </div>

    <div class="stage-content" [class.is-hidden]="previewLoading" [attr.aria-hidden]="previewLoading">
      <app-inline-warning-banner
        *ngIf="reportLimitBannerVisible"
        [title]="'Report limit reached'"
        [message]="'Report limit reached (max 5). Please delete an existing report to generate a new one.'"
        [sticky]="true"
        [showPinnedShadow]="true"
      ></app-inline-warning-banner>

      <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>

      <!-- AOI map is rendered off-screen for capture (not shown in UI). -->
      <div *ngIf="data.aoiTarget" class="aoi-capture-host" aria-hidden="true">
        <app-leaflet-map-wrapper
          class="aoi-map aoi-map-capture"
          #aoiMapWrapper="leafletMapWrapper"
          [rawGeoJson]="data.aoiTarget"
          [pointRenderMode]="'marker'"
          [interactive]="false"
          [showZoomControl]="false"
          [showAttribution]="false"
          [defaultBaseLayer]="'Sentinel'"
          [sentinelOpacity]="0.7"
          [fallbackToOsmOnTileError]="true"
          (statusChange)="onAoiStatusChange($event)"
        ></app-leaflet-map-wrapper>
      </div>

      <div class="preview">
        <div class="preview-header">Map preview</div>

        <div *ngIf="!previewSafeUrl" class="muted">No preview yet.</div>

        <div *ngIf="previewSafeUrl" class="preview-image">
          <img [src]="previewSafeUrl" alt="Map preview" />
        </div>
      </div>

      <!-- Map context is intentionally hidden in the dialog. The same context is now sent to the PDF selections section. -->

      <form [formGroup]="narrativeForm">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" [attr.maxlength]="titleMaxLength" />
          <mat-hint align="end">{{ (narrativeForm.controls.title.value || '').length }}/{{ titleMaxLength }}</mat-hint>
          <mat-error *ngIf="narrativeForm.controls.title.hasError('required')">Title is required</mat-error>
          <mat-error *ngIf="narrativeForm.controls.title.hasError('maxlength')">Max 100 characters</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Remarks</mat-label>
          <textarea matInput rows="5" formControlName="narrative" [attr.maxlength]="remarksMaxLength"></textarea>
          <mat-hint align="end">{{ remarksLength }}/{{ remarksMaxLength }}</mat-hint>
          <mat-error *ngIf="narrativeForm.controls.narrative.hasError('required')">Remarks is required</mat-error>
          <mat-error *ngIf="narrativeForm.controls.narrative.hasError('maxlength')">Max 1000 characters</mat-error>
        </mat-form-field>
      </form>

      <div class="history">
        <div class="history-header">
          <div>Report history</div>
        </div>

        <div *ngIf="historyLoading">Loading...</div>

        <div *ngIf="!historyLoading && reports.length === 0" class="muted">No reports yet.</div>

        <div *ngFor="let r of reports" class="history-row">
          <div class="history-info">
            <div class="history-date">{{ r.createdAtDisplay || '-' }}</div>
            <div class="history-preview">{{ r.title || '' }}</div>
          </div>
          <div class="history-actions">
            <button mat-icon-button type="button" (click)="open(r.reportId)" matTooltip="Open">
              <mat-icon class="material-icons-outlined">open_in_new</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="download(r.reportId)" matTooltip="Download" [disabled]="downloadingReportIds.has(r.reportId)">
              <mat-icon class="material-icons-outlined">download</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="delete(r.reportId)"
              matTooltip="Delete"
              [disabled]="deletingReportIds.has(r.reportId) || loading || historyLoading"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="action-buttons">
  <button mat-stroked-button type="button" (click)="close()">Close</button>
  <button
    class="submit"
    mat-stroked-button
    type="button"
    (click)="generate()"
    [disabled]="narrativeForm.invalid || previewLoading || loading || historyLoading"
  >
    {{ loading ? 'Generating...' : 'Generate Report' }}
  </button>
</mat-dialog-actions>
